function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_13769_15569)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.56844 5.68263H8.08424C8.15401 5.68263 8.21054 5.62606 8.21054 5.55633V2.52474C8.21054 2.45496 8.15401 2.39844 8.08424 2.39844H6.56844C6.49867 2.39844 6.44214 2.45501 6.44214 2.52474V5.55633C6.44214 5.6261 6.49867 5.68263 6.56844 5.68263Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.1853 4.67188H18.3158V5.48028C18.3158 5.9603 17.9622 6.44027 17.4822 6.44027H15.9916C15.4773 6.40381 15.0681 5.99463 15.0317 5.48028V4.67188H8.96848V5.48028C8.93202 5.99463 8.52284 6.40381 8.00848 6.44027H6.51793C6.03791 6.44027 5.68424 5.96025 5.68424 5.48028V4.67188H3.81477C3.16889 4.68566 2.6525 5.21326 2.65265 5.85929V8.96664H21.3474V5.85929C21.3476 5.21326 20.8312 4.68566 20.1853 4.67188Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.9159 5.68263H17.4316C17.5014 5.68263 17.558 5.62606 17.558 5.55633V2.52474C17.558 2.45496 17.5014 2.39844 17.4316 2.39844H15.9159C15.8461 2.39844 15.7896 2.45501 15.7896 2.52474V5.55633C15.7896 5.6261 15.8461 5.68263 15.9159 5.68263Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.65265 20.4634C2.66638 21.0953 3.18267 21.6004 3.81477 21.6003H20.1853C20.8174 21.6004 21.3337 21.0953 21.3474 20.4634V9.72656H2.65265V20.4634ZM7.35162 14.375C7.39195 14.237 7.51178 14.1371 7.65476 14.1224L10.2569 13.7182L11.419 11.3687C11.5234 11.1873 11.7551 11.1249 11.9365 11.2293C11.9944 11.2627 12.0425 11.3108 12.0758 11.3687L13.238 13.7182L15.8401 14.1224C15.983 14.1371 16.1029 14.237 16.1432 14.375C16.189 14.5102 16.1492 14.6596 16.0421 14.754L14.1727 16.5729L14.6274 19.175C14.645 19.3117 14.5869 19.4471 14.4758 19.5287C14.4094 19.5763 14.3302 19.6027 14.2484 19.6044C14.1852 19.6104 14.1221 19.5924 14.0716 19.5539L11.7474 18.3413L9.42321 19.5539C9.29652 19.6311 9.13511 19.621 9.01901 19.5287C8.90794 19.4471 8.84991 19.3116 8.86742 19.175L9.32215 16.5729L7.45269 14.754C7.34563 14.6596 7.30578 14.5101 7.35162 14.375Z",
  fill: "white"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_13769_15569"
}, /*#__PURE__*/React.createElement("rect", {
  width: 19.2,
  height: 19.2,
  fill: "white",
  transform: "translate(2.40002 2.39844)"
})));

var SvgEvent = function SvgEvent(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEvent, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/event.37fa6345.svg";
export { ForwardRef as ReactComponent };